import { useEffect, useState } from 'react';
import enviro from 'enviro';
import I18n from 'I18n';
import UnifiedAuthModal from './UnifiedAuthModal';
import { fetchAppParams, persistSecretId } from './DashworksApi';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The component contains the logic for Dashworks apps:
 * 1. Fetch of app config
 * 2. Store secret ID
 * 3. Open UnifiedAuthModal with necessary params
 *
 * The component could be used with different CTAs,
 * it is actually the alternative to DashworksAuthButton approach
 */

export const DashworksAuthModal = ({
  appId,
  portalId,
  onComplete,
  onCancel,
  onError
}) => {
  const [appConfig, setAppConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(null);
    fetchAppParams(appId).then(resp => {
      if (isMounted) {
        setAppConfig(resp);
      }
    }).catch(err => {
      const errorMessage = err instanceof Error ? err.message : `Failed to load configuration for app ID ${appId}`;
      if (isMounted) {
        setError(errorMessage);
      }
      onError === null || onError === void 0 || onError({
        error: new Error(errorMessage),
        errorMessage: I18n.text('universalAuth.dashworks.errors.failedConfigLoad', {
          appId
        })
      });
    }).finally(() => {
      setIsLoading(false);
    });
    return () => {
      isMounted = false;
    };
  }, [appId, onError]);
  const handleComplete = secretId => {
    if (!appConfig) return;
    void persistSecretId(appConfig.appId, secretId, portalId, appConfig.authenticatorId, appConfig.scope).then(() => {
      onComplete === null || onComplete === void 0 || onComplete(secretId);
    }).catch(persistError => {
      // Even if persistence fails, we still call onComplete since auth succeeded
      // The consuming app can decide how to handle persistence failures
      if (enviro.isQa()) {
        console.error('Failed to persist secret to Dashworks:', persistError);
      }
      onComplete === null || onComplete === void 0 || onComplete(secretId);
    });
  };
  if (!(isLoading || error) && appConfig) {
    return /*#__PURE__*/_jsx(UnifiedAuthModal, {
      portalId: portalId,
      authenticatorId: appConfig.authenticatorId,
      appName: appConfig.appName || `App ${appConfig.appId}`,
      oAuthScope: appConfig.scope,
      appId: appId,
      onComplete: handleComplete,
      onCancel: () => {
        onCancel === null || onCancel === void 0 || onCancel();
      }
    });
  }
  return null;
};